export const onChange = (e) => {
  return e.target.value;
};
export const FilterInputDefProps = {
  value: '',
  propNameLabel: 'Prop Name Label',
  onChange: onChange
};